import { MuiTextField } from 'components/widgets/mui-text-field/TextField';
import { Block } from './Block';
import { Grid, FormHelperText } from '@mui/material';
import { UseStyleHook } from '../hooks/useStyleHook';
import { AccountFormComponentProps } from '../types';
import { SearchableSelect } from 'components/widgets/mui-text-field/SearchableSelect';

export const AccountInformation = ({ value, onChange, selectOptions }: AccountFormComponentProps) => {
    const { defaultProps, defaultDisabledProps, selectProps } = UseStyleHook();

    return (
        <Block
            title="Account ID"
            content={
                <>
                    <Grid item xs={12} md={7}>
                        <SearchableSelect
                            {...selectProps}
                            id="salesforce-account-id"
                            label="Salesforce Account ID"
                            options={selectOptions.salesforceAccounts}
                            value={value.salesforceAccount || ''}
                            onChange={(event) => onChange({ salesforceAccount: String(event?.value) })}
                            InputProps={{
                                ...selectProps.InputProps,
                                sx: { height: '40px', background: 'red' },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <MuiTextField
                            id="salesforce-account-status"
                            label="Salesforce Account Status"
                            onChange={(e) => onChange({ accountStatus: e.target.value })}
                            value={value.accountStatus}
                            {...defaultDisabledProps}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MuiTextField
                            id="salesforce-account-name"
                            label="Account Name"
                            onChange={(e) => onChange({ accountName: e.target.value })}
                            value={value.accountName}
                            {...defaultProps}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MuiTextField
                            id="salesforce-account-domain"
                            label="Client Website Domain"
                            onChange={(e) => onChange({ accountDomain: e.target.value })}
                            value={value.accountDomain}
                            {...defaultDisabledProps}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <MuiTextField
                            id="salesforce-account-se"
                            label="Salesforce Account SE"
                            onChange={(e) => onChange({ accountSE: e.target.value })}
                            value={value.accountSE}
                            {...defaultDisabledProps}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <MuiTextField
                            id="salesforce-account-csm"
                            label="Salesforce Account CSM"
                            onChange={(e) => onChange({ accountCSM: e.target.value })}
                            value={value.accountCSM}
                            {...defaultDisabledProps}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <MuiTextField
                            id="salesforce-account-ae"
                            label="Salesforce Account AE"
                            onChange={(e) => onChange({ accountAE: e.target.value })}
                            value={value.accountAE}
                            {...defaultDisabledProps}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MuiTextField
                            id="salesforce-account-email"
                            label="Account Email"
                            onChange={(e) => onChange({ accountEmail: e.target.value })}
                            value={value.accountEmail}
                            {...defaultProps}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} alignItems="center" display="flex" style={{ paddingTop: 36 }}>
                        <FormHelperText>If used, this will generate the first user invitation</FormHelperText>
                    </Grid>
                </>
            }
        />
    );
};
